import { TextField } from "@mui/material"
import { IAuthorization } from "bets.oddprovider.lib.common.ts/models"
import { ApiClientUtils } from "fwork-jsts-common/src/apiClient"
import { FormItemStyled, FormStyled } from "fwork.react.apptemplate"
import { useSnackbar } from "notistack"
import React, { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { AuthorizationsApiClient } from "../../apiClient/authorizations"
import axios from "../../apiClient/axios"
import { DEFAULTGAP } from "../../globals"
import { FloatActionButton } from "../common/floatActionButton"

export const AuthorizationComponent = (props: {
  id?: number,
}) => {
  const [data, setData] = useState<IAuthorization>()
  const { enqueueSnackbar } = useSnackbar()
  const navigate = useNavigate()
  
  const getData = async () => {
    try {
      const response = await new AuthorizationsApiClient(axios).get({
        where: {
          id: Number(props.id)
        },
        exclude: '_id',
        sort: { name: 1 }
      })

      if (response.success && response?.data?.payload) {
        setData(response.data.payload[0])
      }
    } catch (error) {
      enqueueSnackbar(ApiClientUtils.getErrorMessage(error), { variant: 'error' })
    } finally {
    }
  }

  const [saving, setSaving] = useState<boolean>(false)
  const save = async () => {
    if (data?.default) return

    if (saving) return
    setSaving(true)
    try {
      if (data) {
        const response =
          data.id ? await new AuthorizationsApiClient(axios).put({ data }) : await new AuthorizationsApiClient(axios).post({ data })
        if (response.success) {
          if (response.data?.id)
            data.id = response.data?.id
          enqueueSnackbar('Alterações salvas com sucesso.', { variant: 'success' })
        }
        else
          enqueueSnackbar(response.msg || 'Erro ao salvar alterações.', { variant: 'error' })
      }
    } catch (error) {
      enqueueSnackbar(ApiClientUtils.getErrorMessage(error), { variant: 'error' })
    }
    finally {
      setSaving(false)
    }
  }

  useEffect(() => {
    if (props.id)
      getData()
    else setData({} as IAuthorization)
  }, [])

  return <>
    <FormStyled gap={DEFAULTGAP}>
      <FormItemStyled gap={DEFAULTGAP}>
        <TextField
          disabled={data?.default}
          InputLabelProps={{ shrink: true }}
          value={data?.name || ''}
          label={"Nome"}
          onChange={(e) => setData({
            ...data,
            name: e.target.value
          } as IAuthorization)}
        />
      </FormItemStyled>
    </FormStyled>

    <FloatActionButton progress={saving} onCancelClick={() => navigate(-1)} onConfirmClick={data?.default ? undefined : save} />
  </>
}